import _ from 'lodash';
//import moment from 'moment';
import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
//import Paper from '@material-ui/core/Paper';
//import Grid from '@material-ui/core/Grid';

import StationInvoiceContainer from "../../containers/accounting/StationInvoice";
import StationInvoiceForPdf from "../../components/StationInvoiceForPdf";

const styles = () => {
	return {
		root : {
			position : 'absolute',
			backgroundColor : 'white',
			height: '100%',
			width : '100%',
		},
	};
};

class StationInvoice extends Component {

	constructor(props){
		super(props);
		const stationInvoiceId = _.get(this.props, ['match', 'params', 'stationInvoiceId']);
		const securityHash = _.get(this.props, ['match', 'params', 'securityHash']);

		this.state = {
			stationInvoiceId : (stationInvoiceId) ? parseInt(stationInvoiceId, 10) : undefined,
			securityHash,
			errors : [],
		};
	}

	componentDidMount () {
		//- Only used for updates
		const { publicGetStationInvoice, stationInvoice} = this.props;
		const { stationInvoiceId, securityHash } = this.state;
		if (stationInvoice) { return; }

		publicGetStationInvoice({
			params : {
				stationInvoiceId,
				securityHash,
				includeQuickbooksCustomers : true,
				includeQuickbooksTerms : true,
			},
			callback : (err, r) => {
				if (err) { return this.setState({ errors : [err] }); }
				const stationInvoice = _.get(r, ['collections', 'stationInvoiceCollection', 0]);
				if (!stationInvoice) { return {errors : ['Missing station invoice.']}; }
				return this.setState({ stationInvoice });
			}
		});
	}

	render() {
		const {
			classes,
			stationInvoice,
			quickbooksCustomerMap,
			stationMap,
			quickbooksTermMap,
		} = this.props;

		const {
			errors,
		} = this.state;

		if (errors.length) {
			return (<div>
				<div>Encountered an error when retrieving the invoice</div>
				{errors.map((error,i) => {
					return (<div key={i}>{error}</div>);
				})};
			</div>);
		}

		if (!stationInvoice) {
			return (<div>Fetching station invoice...</div>);
		}

		return (<div className={classes.root}>
			<StationInvoiceForPdf
				stationInvoice={stationInvoice}
				quickbooksCustomerMap={quickbooksCustomerMap}
				quickbooksTermMap={quickbooksTermMap}
				stationMap={stationMap}
			/>
		</div>);
	}
}

StationInvoice.propTypes = {
	classes: PropTypes.object.isRequired,
	showErrors : PropTypes.func,

	//- Batch
	publicGetStationInvoice : PropTypes.func,
	stationInvoice : PropTypes.object,
	quickbooksCustomerMap : PropTypes.object,
	quickbooksTermMap : PropTypes.object,
	stationMap : PropTypes.object,
};

export default _.flow([
	withStyles(styles),
	StationInvoiceContainer,
])(StationInvoice);

